import logo from "./images/logo.png";
import swieta from "./images/swieta.png";
import jarmark from "./images/jarmark.jpg";
import litwa from "./images/litwa.png";
import backToSchool from "./images/backToSchool.png"

export const news = [
    {
        id: 'wilno-jarmark-kaziukowy',
        title: 'Zapraszamy na wyjazd do Wilna',
        firstSentence: 'Zapraszamy na wyjątkowy wyjazd do Wilna na Jarmark Kaziukowy...',
        date: '09-02-2026',
        photo: jarmark,
    },
    {
        id: 'nowy-rozklad-jazdy',
        title: 'Nowy rozkład jazdy',
        firstSentence: 'Drodzy Pasażerowie Informujemy, iż od 01.01.2026 nieznacznie...',
        date: '28-12-2025',
        photo: logo,
    },
    {
        id: 'zyczenia-swiateczne',
        title: 'Życzenia Świąteczne',
        firstSentence: 'Z okazji Świąt Bożego Narodzenia oraz nadchodzącego Nowego Roku...',
        date: '24-12-2025',
        photo: swieta,
    },
    {
        id: 'przypomnienie-nowy-rok-szkolny',
        title: 'Zbliża się nowy rok szkolny – czas na zakup biletów miesięcznych!',
        firstSentence: 'Przypominamy dzieciom, młodzieży i ich rodzicom, że nowy rok...',
        date: '27-08-2025',
        photo: backToSchool,
    },
    {
        id: 'wyjazd-na-litwe',
        title: 'Zapraszamy na wycieczkę na Litwę',
        firstSentence: 'KOWNO – KIEJDANY – WILNO – 2 dni pełne wrażeń...',
        date: '10-08-2025',
        photo: litwa,
    },
    {
        id: 'informacja-utrudnienia',
        title: 'Informacja - nieczynny przystanek na ul. Goniądzkiej',
        firstSentence: 'Drodzy Pasażerowie! Informujemy, że w dniach 9 -10 lipca 2025 r. w związku...',
        date: '08-07-2025',
        photo: logo,
    },
];